/* tslint:disable */

/**
 */
export class TemperatureDrawing {
    getRightLimit?: number;
    svgXsize?: number;
    x0?: number;
    y0?: number;
    xsize?: number;
    ysize?: number;
    getYTopGraduate?: number;
    getYTopLegend?: number;
    getXquarter?: number;
    getXmedium?: number;
    getXThreeQuarter?: number;
    svgYsize?: number;
    getBottomLimit?: number;
    getYBottomGraduate?: number;
    getYBottomLegend?: number;
    getXArrow?: number;
    getYArrow?: number;
    getXArrowRight?: number;
    getXArrowLeft?: number;
    getTextArrow?: number;
    getYMediumSVG?: number;
    getTempMin?: number;
    getTempMax?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/temperature-drawing.ts